import React from 'react';
import Select from 'react-select';
import analytics from '@nerdwallet/analytics';
import { Tracking } from '@nerdwallet/nw-client-lib';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { filter } from 'lodash';
import { FORM_NAME } from '../../../../../lib/analytics-constants';

type CityInputProps = {
  cityValue: string;
  clearable?: boolean;
  autoFocus?: boolean;
  cityItems: {
    label: string;
    value: any;
    clearableValue: boolean;
    state: any;
  }[];
  formName: string;
  fieldName: string;
  cityType: string;
  onChangeCity: string;
  onChange: (value: any, key: any) => void;
};

const filterOptions = (options, searchTerm) => {
  const query = searchTerm.toLowerCase();
  const optionsWithAllStates = filter(options, (option) => {
    if (option.isState) {
      // return all states because we will filter them out later
      return true;
    }
    if (option.state.toLowerCase().includes(query)) {
      // search by state
      return true;
    }
    if (option.label.toLowerCase().includes(query)) {
      // search by city or state abbr
      return true;
    }
    // no matches
    return false;
  });

  // filter out states that have no cities - 2 disabled options in a row
  return filter(optionsWithAllStates, (option, index) => {
    if (!optionsWithAllStates[index + 1]) {
      // last option so just check if it is a state
      return !option.isState;
    }
    return !(option.isState && optionsWithAllStates[index + 1].isState);
  });
};

const { formInputChanged } = Tracking;
const placeholder = 'Select city';

const CityInputSelect = ({
  cityValue,
  clearable = false,
  autoFocus = false,
  cityItems,
  formName,
  fieldName,
  cityType,
  onChangeCity,
  onChange,
}: CityInputProps): JSX.Element => {
  return (
    <Select
      autoBlur
      clearable={clearable}
      autoFocus={autoFocus}
      value={cityValue}
      placeholder={placeholder}
      options={cityItems}
      filterOptions={filterOptions}
      style={{ minHeight: '44px' }}
      onChange={(config) => {
        const value = config?.value;
        formInputChanged({
          formName,
          fieldName,
          fieldValue: value,
        });

        analytics.track('cost_of_living_city_updated', {
          form_name: FORM_NAME.COST_OF_LIVING,
          page_number: null,
          total_pages: null,
          is_valid: true, // there is no validation
          was_prefilled: true,
          value_s: value,
          additional_attributes: {
            city_type: cityType,
          },
        });
        onChange(value, onChangeCity);
      }}
    />
  );
};

CityInputSelect.displayName = 'CityInputSelect';

export default CityInputSelect;
